export const includes = (array: (number | null)[], item: number | null) =>
  array.indexOf(item) >= 0;
